import { filterDataTickets } from './filterData';

const optionFields = {
    tipo: 'nombreTipo',
    instalacion: 'instalacionUsuario',
    usuario: 'nombreUsuario',
    responsable: 'nombreResponsable'
};

const isOption = value => typeof value === 'string' && value.trim() !== '' && value !== '*';

const getTicketFilterOptions = (tickets = [], filters = {}) => {
    return Object.fromEntries(Object.entries(optionFields).map(([filter, field]) => {
        // Cada lista respeta los otros filtros y permite cambiar su propia selección.
        const matchingTickets = filterDataTickets(tickets, {...filters, [filter]: '*'});
        const options = new Set(matchingTickets.map(ticket => ticket[field]).filter(isOption));

        if (isOption(filters[filter])) {
            options.add(filters[filter]);
        }

        return [filter, [...options].sort((a, b) => a.localeCompare(b))];
    }));
};

export default getTicketFilterOptions;
